export const NoteActionTypes = {
  send: 'SEND',
  sendDraft: 'SEND-DRAFT',
  writeConsult: 'WRITECONSULT',
  writeConsultDraft: 'WRITECONSULT-DRAFT',
  askForMoreInfo: 'ASKFORMOREINFO',
  askForMoreInfoDraft: 'ASKFORMOREINFO-DRAFT',
  decline: 'DECLINE',
  declineDraft: 'DECLINE-DRAFT',
  reply: 'REPLY',
  replyDraft: 'REPLY-DRAFT',
  finish: 'FINISH',
  reopen: 'REOPEN',
  reopenDraft: 'REOPEN-DRAFT',
  recomplete: 'RECOMPLETE',
  cancel: 'CANCEL',
  forward: 'FORWARD',
  forwardDraft: 'FORWARD-DRAFT',
  addNote: 'ADDNOTE',
  assign: 'ASSIGN',
  unassign: 'UNASSIGN',
  draft: 'DRAFT',
  addNoteDraft: 'ADDNOTE-DRAFT',
  assignDraft: 'ASSIGN-DRAFT',
  unassignDraft: 'UNASSIGN-DRAFT'
};
